import React from "react"
import {
  NavElement,
  NavLink,
  NavList,
  Wrapper,
  Indicator,
  Logo,
} from "./styles"
import LanguageSelector from "./languageSelector/languageSelector"
import logoSrc from "../../../assets/logo.png"
import { useSelector } from "react-redux"
import { Link } from "gatsby"

const romanianNumber = [
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
]

const SideBar = ({ path, routesQuery, lang }) => {
  const { navigation } = routesQuery.chapter[lang.toLowerCase()]
  const routes = Object.values(navigation)
  const isHideSidebar = useSelector(state => state.hideSidebar)

  return (
    <Wrapper isHideSidebar={isHideSidebar}>
      <Link to="/">
        <Logo src={logoSrc} />
      </Link>
      <NavList isHideSidebar={isHideSidebar}>
        {routes.map(({ name, route }, index) => (
          <NavElement key={name}>
            <NavLink
              activeClassName="active"
              to={route.content}
              after={name.content}
              before={romanianNumber[index]}
              style={{ marginTop: index === 0 && "0" }}
            >
              <Indicator />
            </NavLink>
          </NavElement>
        ))}
      </NavList>
      <LanguageSelector path={path} hide={isHideSidebar} />
    </Wrapper>
  )
}

export default SideBar
